module.exports = __webpack_public_path__ + "img/border_RightArrow2.f5957ef8.svg";